import styled from "styled-components"

import {breakWord} from "@irati/ui/src/global/helpers"
import {Dosis} from "@irati/ui/src/global/fonts"

const ProductCode = styled.div`
  font-size: 28px;
  line-height: 35px;
  font-family: ${Dosis};
  margin-bottom: 7px;
  margin-top: -5px;
  ${breakWord}
`

export default ProductCode
